import Api from '@/services/Api'
import store from '@/store/store'

export default {
	index (search) {
		return Api().get('groups', {
			params: {
				search: search,
				testType: store.state.testType
			}
		})
	},
	show (groupId) {
		return Api().get(`groups/${groupId}`)
	},
	post (group) {
		return Api().post('groups', group)
	},
	put (group) {
		return Api().put(`groups/${group.id}`, group)
	},
	delete (groupId) {
		return Api().delete(`groups/${groupId}`)
	}
}



// WEBPACK FOOTER //
// ./src/services/GroupsService.js